/**
 * @desc Export table layout configuration.
 * @example
 * import { layoutConfig } from 'config/table-configs/rx-claims-list';
 */
export const layoutConfig = {
    dimensions: {
        maxHeight: 260,
        padding: 0,
    },
    columnWidth: {
        claimNumber: 80,
        drugName: 120,
        status: 80,
        filedOn: 80,
        processedDate: 80,
        youPaid: 50,
        planPaid: 50,
        
        // special columns
        _selectionActions: 16, // checkbox selection
        _groupActions: 100, // group actions column
    },
    filterFlyoutWidths: {
        rxNumber: 180,
        status: 300
    },
    valueColors: {},
    actionIcons: {
        toDos: 'checkedContent',
        renewRx: 'checkedContent',
        refillRx: 'checkedContent',
        checkout: 'cart'
    },
};
